module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/_path.js
// module id = 384
// module chunks = 0